import * as React from 'react';
import Stepper from '@material-ui/core/Stepper';

const CustomStepper = React.forwardRef((props, ref) => {
    return <Stepper {...props} ref={ref} />;
});

export { CustomStepper as Stepper };
